<template>
  <div class="product-description">
    <div class="product-description__header">
      <h1>Product description</h1>
    </div>

    <div id="faq">
      <ul>
        <li>
          <input type="checkbox" checked />
          <i></i>
          <h2>Microwave-adjusted Global HydroEstimator (MWGHE)</h2>
          <p>
            Accumulations of rainfall estimates from the microwave-adjusted GHE
            over the last 6 hours ending on the current navigation hour
            (mm/6hr).
          </p>
        </li>
        <li>
          <input type="checkbox" checked />
          <i></i>
          <h2>Global HydroEstimator (GHE)</h2>
          <p>
            Accumulations of rainfall estimates from the Global HydroEstimator
            over the last 6 hours ending on the current navigation hour
            (mm/6hr).
          </p>
        </li>
        <li>
          <input type="checkbox" checked />
          <i></i>
          <h2>Gauge Mean Areal Precipitation (GMAP)</h2>
          <p>
            6-hour accumulations of MAP(mm) estimates for each sub-basin
            produced from interpolation of precipitation gauge data ending on
            the current navigation hour.
          </p>
        </li>
        <li>
          <input type="checkbox" checked />
          <i></i>
          <h2>Merged Mean Areal Precipitation (MAP)</h2>
          <p>
            Accumulations of MAP estimates for a sub-basin over the last 6 hours
            ending on the current navigation hour using best available mean
            areal precipitation estimates from bias-adjusted MWGHE or
            bias-adjusted GHE or the gauge-interpolations (mm/6hr).
          </p>
        </li>
        <li>
          <input type="checkbox" checked />
          <i></i>
          <h2>Average Soil Moisture (ASM)</h2>
          <p>
            Shows the fraction of saturation of the upper soil (20-30 cm) of the
            SAC-SMA for each of the sub-basin.
          </p>
        </li>
        <li>
          <input type="checkbox" checked />
          <i></i>
          <h2>Flash Flood Guidance (FFG)</h2>
          <p>
            Required rainfall over the next 6 hours to cause bankfull flow at
            the outlet of the catchment. Consequently, rainfall volumes of the
            same duration that are greater than the FFG value indicate a
            likelihood of overbank flows at catchment outlet.
          </p>
        </li>
        <li>
          <input type="checkbox" checked />
          <i></i>
          <h2>Imminent Flash Flood Threat (IFFT)</h2>
          <p>
            Difference of 06-hr FFG from a previous model processing hour and
            06-hr MAP observed over the following 6 hours (mm/6hr).IFFT provides
            the forecaster with an idea of likely regions of imminent flash
            flood threats. Note that this set of products concerns the past
            rainfall and should be evaluated before using for warnings.
          </p>
        </li>
        <li>
          <input type="checkbox" checked />
          <i></i>
          <h2>Forecasted Mean Areal Precipitation (FMAP)</h2>
          <p>
            Accumulated MAP forecasted to occur over 6 hr beginig from the
            navigation hour(mm/6hr).
          </p>
        </li>
        <li>
          <input type="checkbox" checked />
          <i></i>
          <h2>Forecasted Flash Flood Threat (FFFT)</h2>
          <p>
            Provides the forecaster with an idea of regions forecasted to be
            concern for flash flooding based on the difference of FMAP forecasts
            of MAP and the corresponding current FFG (mm/6hr).
          </p>
        </li>
        <li>
          <input type="checkbox" checked />
          <i></i>
          <h2>4-Day Average Lower SM</h2>
          <p>
            The average lower-zone soil-water saturation fraction over a 4-day
            period ending at present time, mapped onto the Global Hydroestimator
            satellite pixels. The 6-hourly mean areal estimates of the
            lower-zone soil-water saturation fraction are used to produce the
            averages over each delineated small basin on the domain of the flash
            flood guidance system prior to their mapping onto the GHE grid
            scale.
          </p>
        </li>
        <li>
          <input type="checkbox" checked />
          <i></i>
          <h2>Maximum Precipitation (Merged Maximum Neighbor Precipitation)</h2>
          <p>
            The total 24 hour accumulation, ending at the current hour, of the
            maximum bias-adjusted precipitation estimate selected hourly from
            the nearest 9 grid points for each GHE pixel of interest in the
            landslide hazard assessment module. The gridded maximum neighbor
            precipitation value reflects a merging of the best-available input
            product selected from the bias-adjusted MWGHE precipitation and the
            bias-adjusted GHE.
          </p>
        </li>
        <li>
          <input type="checkbox" checked />
          <i></i>
          <h2>Landslide Threat Index</h2>
          <p>
            The gridded index on each GHE pixel of interest in the landslide
            hazard assessment module indicating likelihood of landslide
            occurrence. The index is computed by identifying the locations with
            4-day average lower-zone soil water saturation fraction and 24-hr
            maximum merged nearest neighbor precipitation greater than given
            threshold values.Pixels identified as exceeding the given threshold
            are considered as high likelihood of landslide occurrence.These high
            likelihood pixels are assigned an index value of 1.0 in the text
            export and colored red in the image exports.
          </p>
        </li>
        <li>
          <input type="checkbox" checked />
          <i></i>
          <h2>Flash Flood Risk (FFR)</h2>
          <p>
            Flash Flood Risk is a measure of the forecast flash flood occurrence
            frequency. Flash Flood Risk products include text tables and images
            of 12-hour, 24-hour and 36-hour relative frequency of positive flash
            flood threat for the entire forecast lead time interval that is due
            to forecast rainfall of 1-, 3-, or 6-hour duration from each
            available model forecast. Note that the quality of this product
            depends critically on the reliability of the rainfall forecast
            throughout the lead time interval.
          </p>
        </li>
      </ul>
      <div class="product-description__mouse">
        <!-- <p>Scroll down for more</p> -->
        <!-- <MouseScrollDown /> -->
      </div>
    </div>
  </div>
</template>

<script>
//import MouseScrollDown from "../UI/MouseScrollDown.vue";

export default {
  components: {
    //MouseScrollDown,
  },
};
</script>

<style lang="scss" scoped>
@import "../../sass/_variables.scss";

.product-description {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 5rem;
  height: 90%;
  border-bottom: solid 1px $color-white;

  &__header {
    text-align: center;
    color: $color-white;
    font-size: 1.5rem;
    border-bottom: solid 1px $color-white;
  }
}

#faq {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  overscroll-behavior: none;
  height: 80%;
  max-width: 700px;
  margin: auto;
  padding: 0 15px;
  text-align: center;
}

section.faq {
  padding-top: 2em;
  padding-bottom: 3em;
}

#faq ul {
  text-align: left;
}
.transition,
p,
ul li i:before,
ul li i:after {
  transition: all 0.3s;
}

#faq .no-select,
#faq h2 {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  user-select: none;
}

#faq h1 {
  color: #000;
  margin-bottom: 30px;
  margin-top: 0;
}

#faq h2 {
  color: $color-tertiary;
  font-size: 1.2rem;
  line-height: 34px;
  text-align: left;
  padding: 15px 15px 0;
  text-transform: none;
  font-weight: 500;
  letter-spacing: 1px;
  display: block;
  margin: 0;
  cursor: pointer;
  transition: 0.2s;
}

#faq p {
  color: #333;
  text-align: left;
  font-size: 14px;
  line-height: 1.45;
  position: relative;
  overflow: hidden;
  max-height: 250px;
  will-change: max-height;
  contain: layout;
  display: inline-block;
  opacity: 1;
  transform: translate(0, 0);
  margin-top: 5px;
  margin-bottom: 15px;
  padding: 0 50px 0 15px;
  transition: 0.3s opacity, 0.6s max-height;
  hyphens: auto;
  z-index: 2;
}

#faq ul {
  list-style: none;
  perspective: 900;
  padding: 0;
  margin: 0;
}
#faq ul li {
  position: relative;
  overflow: hidden;
  padding: 0;
  margin: 0;
  /*padding-bottom: 4px;*/
  /*padding-top: 18px;*/
  background: $color-grey-light-2;
  box-shadow: 0 3px 10px -2px rgba(0, 0, 0, 0.1);
  -webkit-tap-highlight-color: transparent;
  border-radius: 1rem;
}
#faq ul li + li {
  margin-top: 15px;
}
#faq ul li:last-of-type {
  padding-bottom: 0;
}
#faq ul li i {
  position: absolute;
  transform: translate(-6px, 0);
  margin-top: 28px;
  right: 15px;
}
#faq ul li i:before,
ul li i:after {
  content: "";
  position: absolute;
  background-color: $color-tertiary;
  width: 3px;
  height: 9px;
}
#faq ul li i:before {
  transform: translate(-2px, 0) rotate(45deg);
}
#faq ul li i:after {
  transform: translate(2px, 0) rotate(-45deg);
}
#faq ul li input[type="checkbox"] {
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0;
  touch-action: manipulation;
}
#faq ul li input[type="checkbox"]:checked ~ h2 {
  color: #000;
}
#faq ul li input[type="checkbox"]:checked ~ p {
  /*margin-top: 0;*/
  max-height: 0;
  transition: 0.3s;
  opacity: 0;
  /*transform: translate(0, 50%);*/
}
#faq ul li input[type="checkbox"]:checked ~ i:before {
  transform: translate(2px, 0) rotate(45deg);
}
#faq ul li input[type="checkbox"]:checked ~ i:after {
  transform: translate(-2px, 0) rotate(-45deg);
}

a,
a:visited,
a:focus,
a:active,
a:link {
  text-decoration: none;
  outline: 0;
}

a {
  color: currentColor;
  transition: 0.2s ease-in-out;
}

h1,
h2,
h3,
h4 {
  margin: 0.3em 0;
}

ul {
  padding: 0;
  list-style: none;
}

img {
  vertical-align: middle;
  height: auto;
  width: 100%;
}
</style>
